module.exports = __webpack_public_path__ + "static/media/car-battery.2c0a372a.svg";